<template>
  <div class="login_wrapper">
    <div class="loginbg">
      <div class="login-flex mc-flex mc-flex-justify-end mc-items-center">
        <div class="login-wrap">
          <div class="login-logo"><img src="../assets/login/logo.png" /></div>
          <div class="login-title">欢迎登录齐心BMS业务管理平台</div>

          <div class="login-toggle" @click="loginToggle()">
            <img src="../assets/login/toggle_qrcode.png" v-show="loginActive == 1" />
            <img src="../assets/login/toggle_form.png" v-show="loginActive == 2" />
          </div>
          <!-- 账号密码登录 -->
          <el-form :model="loginForm" :rules="loginRules" ref="loginForm" v-show="loginActive == 1">
            <el-form-item prop="loginName">
              <el-input v-model="loginForm.loginName" placeholder="请输入账号">
                <i slot="prefix" class="el-input__icon login-icon icon-user"></i>
              </el-input>
            </el-form-item>
            <el-form-item prop="password">
              <el-input type="password" v-model="loginForm.password" placeholder="请输入密码" show-password>
                <i slot="prefix" class="el-input__icon login-icon icon-password"></i>
              </el-input>
            </el-form-item>
            <!-- 无痕验证容器（由 SDK 在需要时弹出） -->
            <el-form-item style="height: 0; margin-bottom: 0; overflow: hidden;">
              <div id="captcha-element" style="display: none;"></div>
            </el-form-item>
            <el-form-item class="login-btn">
              <el-button type="primary" @click.native.prevent="handleLogin">登 录</el-button>
            </el-form-item>
          </el-form>

          <!-- 扫码登录 -->
          <div class="loginQrcode" v-show="loginActive == 2">
            <div class="ww_login" id="ww_login"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import menuListJson from "@/common/menuList.js";
import { Encrypt } from "@/common/AESUtils.js";
export default {
  name: "login",
  data() {
    return {
      loginActive: 1, //1:账号密码登录，2:扫码登录
      wwLogin: null,// 企业微信登录组件
      loginForm: {
        loginName: "",
        password: "",
        /** 阿里云验证码2.0 success 回调参数，原样提交服务端 */
        captchaVerifyParam: "",
      },
      captchaPendingSubmit: false,
      loginRules: {
        loginName: { required: true, message: "请输入账号", trigger: "blur" },
        password: { required: true, message: "请输入密码", trigger: "blur" },
      }
    };
  },

  // 监听路有变化获取code参数值
// watch: {
//   "$route.query": {
//     handler(newVal, oldVal) {
//       console.log(11)
//       this.authCode = this.$route.query["code"];//获取到code，调用后端接口换取token
//       this.loginCheck()
//     },
//     deep: true
//   },
// },
  mounted() {
    if (this.$route.query["code"]) {
      this.loginForm.password = "";
      this.getUserMsg(this.$route.query["code"], "");
    } else {
      this.showWxLogin();
    }
  },
  beforeDestroy() {
    if (this.captcha && this.captcha.destroy) {
      this.captcha.destroy();
    }
  },
  // unmounted() {
	// if(this.wwLogin){
	// 	this.wwLogin.unmount()
  //   this.wwLogin.destroyed()
	// }
  // },
  created() {
    this.getCheckCode();
  },
  methods: {
    /**
     * 账号密码登录入口：先表单校验，再触发无痕验证或提交登录。
     */
    handleLogin() {
      if (this.$route.query["code"]) {
        this.getUserMsg(this.$route.query["code"], "");
        return;
      }
      this.$refs["loginForm"].validate((valid) => {
        if (!valid) {
          return;
        }
        if (!this.loginForm.captchaVerifyParam) {
          this.triggerTracelessVerify();
          return;
        }
        this.submitLogin();
      });
    },
    /**
     * 表单通过后发起登录请求（含已拿到的 captchaVerifyParam）。
     */
    async submitLogin() {
      const result = await this.getUserMsg("", this.loginForm.captchaVerifyParam);
      if (!result) {
        this.resetCaptchaAfterLoginFail();
      }
    },
    /**
     * 触发阿里云验证码2.0无痕验证。
     */
    triggerTracelessVerify() {
      if (!this.captcha || !this.captcha.startTracelessVerification) {
        this.$message({ type: "error", message: "验证码初始化失败，请刷新后重试" });
        return;
      }
      this.loginForm.captchaVerifyParam = "";
      this.captchaPendingSubmit = true;
      try {
        if (this.captcha.show) {
          this.captcha.show();
        }
        this.captcha.startTracelessVerification();
      } catch (e) {
        this.captchaPendingSubmit = false;
        this.$message({ type: "error", message: "验证码触发失败，请重试" });
      }
    },
    /**
     * 登录失败或需重新验证时重置验证码状态。
     */
    resetCaptchaAfterLoginFail() {
      this.loginForm.captchaVerifyParam = "";
      this.captchaPendingSubmit = false;
      if (this.captcha && this.captcha.hide) {
        this.captcha.hide();
      }
      if (this.captcha && this.captcha.refresh) {
        this.captcha.refresh();
        return;
      }
      this.initCode();
    },
    // 加载验证码 SDK
    getCheckCode() {
      window.AliyunCaptchaConfig = {
        region: "cn",
        prefix: "116s1l",
      };
      let script = document.createElement("script");
      script.type = "text/javascript";
      script.src = "https://o.alicdn.com/captcha-frontend/aliyunCaptcha/AliyunCaptcha.js";
      document.body.appendChild(script);
      script.onload = () => {
        this.initCode();
      };
    },
    /** 初始化验证码2.0（popup + 无痕） */
    initCode() {
      const _this = this;
      const sceneId = "lgimqnwf";
      window.initAliyunCaptcha({
        SceneId: sceneId,
        mode: "popup",
        element: "#captcha-element",
        slideStyle: { width: 400, height: 40 },
        language: "cn",
        getInstance(instance) {
          _this.captcha = instance;
        },
        success(captchaVerifyParam) {
          _this.loginForm.captchaVerifyParam = captchaVerifyParam;
          if (_this.captchaPendingSubmit) {
            _this.captchaPendingSubmit = false;
            _this.submitLogin();
          }
        },
        fail() {
          _this.loginForm.captchaVerifyParam = "";
          _this.captchaPendingSubmit = false;
        },
        onError() {
          _this.loginForm.captchaVerifyParam = "";
          _this.captchaPendingSubmit = false;
        },
      });
    },
    showWxLogin() {
      const redirectUri = window.location.href
      new WwLogin({
          "id": "ww_login",
          "appid": this.wxLogin.appid,
          "agentid": this.wxLogin.agentid,
          "redirect_uri": encodeURIComponent(redirectUri),
          "state": Date.now() + this.wxLogin.appid,
          //"href": "",
          "lang": "zh",
      });
    },
    async getUserMsg(code, captchaVerifyParam) {
      let res = await this.$api.login({
        username: this.loginForm.loginName,
        password: Encrypt(this.loginForm.password.trim()).toString(),
        emAuthCode: code,
        captchaVerifyCallbackParam: captchaVerifyParam,
      }).catch(() => {
        return false;
      });
      if (!res || res === false) {
        return false;
      }
      if (res.code === 200) {
        sessionStorage.setItem("TOKEN", res.result.loginToken);
        sessionStorage.setItem("UID", res.result.userId);
        sessionStorage.setItem("UNAME", res.result.username);
        sessionStorage.setItem("ORGID", res.result.orgId);
        sessionStorage.setItem("ROLEIDLIST", JSON.stringify(res.result.roleIdList));
        sessionStorage.setItem("WORKCODES", JSON.stringify(res.result.workCodes));
        sessionStorage.setItem("ROLEID", res.result.roleId);
        sessionStorage.setItem("ROLENAME", res.result.roleName);
        sessionStorage.setItem("NICKNAME", res.result.nickName);
        sessionStorage.setItem("MOBILE", res.result.mobile);
        sessionStorage.setItem("EMAIL", res.result.email);
        sessionStorage.setItem("PLATFORMCODE", res.result.platformCode);
        sessionStorage.setItem("PLATFORMNAME", res.result.platformName);
        this.$store.dispatch("set_name", res.result.username);
        // 计算并设置是否隐藏回款相关字段
        sessionStorage.setItem("shouldHideReturnFields", res.result.isExternalAudit === 1);
        sessionStorage.setItem("MENULIST", JSON.stringify(res.result.menuList));
        sessionStorage.setItem("ALLENTERPRISEINFOLIST", JSON.stringify(res.result.enterpriseInfoList));
        sessionStorage.setItem("PAYTYPELIST", JSON.stringify(res.result.payTypeList));
        sessionStorage.setItem("userInfo", JSON.stringify(res.result));
        let enterpriseInfoList = [];
        if (res.result.enterpriseInfoList.length > 0) {
          res.result.enterpriseInfoList.forEach((val) => {
            if (res.result.orgIdList.indexOf(val.companyCode) != -1) {
              enterpriseInfoList.push(val);
            }
          })
        };
        sessionStorage.setItem("ENTERPRISEINFOLIST", JSON.stringify(enterpriseInfoList));

        let qqsEnterpriseInfoList = [];
        if (enterpriseInfoList.length > 0) {
          enterpriseInfoList.forEach((val) => {
            if (res.result.qqs.indexOf(val.companyCode) != -1) {
              qqsEnterpriseInfoList.push(val);
            }
          })
        };
        sessionStorage.setItem("QQSENTERPRISEINFOLIST", JSON.stringify(qqsEnterpriseInfoList));
        await this.queryPrivileges();

        /* if(res.result.menuList && res.result.menuList.length>0){
            res.result.menuList.some(item=>{
                let flag = false;
                let oneIndex = item.imgPath;
                if(menuListJson[oneIndex]){
                    item.children.some(item2=>{
                        let twoIndex = item2.imgPath;
                        if(menuListJson[oneIndex].children[twoIndex]){
                            this.$router.replace({
                                path: menuListJson[oneIndex].children[twoIndex].path
                            });
                            flag = true;
                            return true;
                        }
                    });
                };
                return flag;
            });
        }; */

        this.$store.commit("SET_TOKEN", res.result.loginToken);


        this.$store.dispatch("getTopLists", 1);
        // this.$store.dispatch("getTopLists", 2);
        this.$store.dispatch("getTopLists", 3);
        this.$store.dispatch("getTopLists", 4);
        this.$store.dispatch("getTopLists", 5);
        this.$store.dispatch("getTopLists", 7);
        this.$store.dispatch("getTopLists", 10);
        this.$store.dispatch("getTopLists", 11);
        this.$store.dispatch("getTopLists", 13);
        this.$store.dispatch("getTopLists", 15);
        this.$store.dispatch("getTopLists", 16);
        this.$store.dispatch("getTopLists", 18);
        this.$store.dispatch("getdropdownList", 2);
        this.$store.dispatch("getdropdownList", 4);
        this.$store.dispatch("getdropdownList", 17);

        // if (process.env.NODE_ENV == "development") {
        //   window.open(`http://172.18.68.79:8080/#/`);
        // }

        // this.$router.replace({path: '/home'});
        window.location.href = '/home';
        return true
      }else{
        this.$router.replace({path: '/login'});
        //window.nc.reset();
        return false
      }
    },
    // 查询用户权限
    async queryPrivileges() {
      let res = await this.$api.queryPrivileges();
      if (res.code === 200) {
        sessionStorage.setItem("PRIVILEGES", JSON.stringify(res.result));
      };
    },
    // 切换登录方式
    loginToggle() {
		// if(this.wwLogin){
		// 	this.wwLogin.unmount()
		// }
		if (this.loginActive == 1) {
			setTimeout(()=>{this.showWxLogin()}, 1);
			this.loginActive = 2;
		} else {
			this.loginActive = 1;
		}
    },
  }
};
</script>
<style lang="less" scoped>
.login_wrapper {
  width: 100%;
  height: 100%;
  line-height: 20px;
  font-size: 12px;
  position: relative;

  img {
    vertical-align: top;
  }

  .link {
    color: #409EFF;
  }

  .loginbg {
    width: 100%;
    height: 100%;
    background: url(../assets/login/bg.png) no-repeat center center;
    background-size: cover;
  }

  .login-flex {
    width: 100%;
    height: 100%;
    max-width: 1400px;
    padding: 15px 30px;
    margin: 0 auto;
    box-sizing: border-box;
  }
}

.login-wrap {
  width: 474px;
  background: rgba(255, 255, 255, 0.7);
  border-radius: 25px;
  box-shadow: 0px 0px 14px 0px #EBEBEB;
  box-sizing: border-box;
  padding: 40px 35px 50px;
  position: relative;

  .login-logo {
    text-align: center;
  }

  .login-title {
    line-height: 28px;
    margin-top: 30px;
    text-align: center;
    font-size: 22px;
    color: #3B2C2D;
  }

  /deep/.el-form {
    margin-top: 50px;

    .el-input__inner {
      height: 48px;
      line-height: 46px;
      padding-left: 36px;
    }

    .el-input__clear {
      line-height: 48px;
      font-size: 18px;
    }

    .el-checkbox__label {
      color: #333;
    }
  }

  .login-icon {
    display: inline-block;
    width: 32px;
    background-repeat: no-repeat;
    background-position: center;
    vertical-align: top;

    &.icon-user {
      background-image: url(../assets/login/icon_user.png);
    }

    &.icon-password {
      background-image: url(../assets/login/icon_password.png);
    }
  }

  .login-btn {
    margin-bottom: 0;

    .el-button {
      width: 100%;
      height: 48px;
    }
  }

  .login-toggle {
    position: absolute;
    top: 0;
    right: 0;
    width: 80px;
    height: 80px;
    overflow: hidden;
    cursor: pointer;

    img {
      position: absolute;
      right: 0;
      top: 0;
    }
  }

  .loginQrcode {
    #ww_login {
      margin: 0 auto;
      width: 320px;
    }
  }
}
</style>
